import React from 'react'
import Header from '../../common/Header'
import BlogSection from './components/BlogSection'
import Footer from '../../common/Footer'
import ExternalScripts from '../../common/ExternalScripts'

const Blog = () => {
  return (
    <div>
        <Header preclass="modified" modifiedHeader={true}/>
      <ExternalScripts/>
        
        <BlogSection/>
        <Footer/>
      
    </div>
  )
}

export default Blog
